import { formatNumber } from "./LocaleFormat";

export const formatLocalizedNumber = (value, language = "de") => formatNumber(value, language, {
  maximumFractionDigits: 20,
});

export const formatGermanNumber = (value) => formatLocalizedNumber(value, "de");
